module.exports = "<sb-grid flex source=\"vm.source\" config=\"vm.config\" transform=\"vm.transform\" actions=\"vm.actions\" empty-state=\"vm.emptyState\" columns=\"vm.columns\"></sb-grid>\n";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/tasks-grid/tasks-grid.template.html
// module id = 1262
// module chunks = 0